import React, { useEffect, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import { isTabletOrMobileQuery } from '../../utils'
import * as yup from 'yup'
import { FieldValues, useForm, UseFormGetValues } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { useSelector } from 'react-redux'

import { DateOfBirthField, DisabledField, FirstNameField, GenderField, HandicapField } from './ParticipantFormFields'
import { ISibling } from '../../store/participant/interfaces'
import { siblingSchema } from './ParticipantSchemaDefinitions'
import { Validator } from '../../hooks/validators'
import { checkProperAge } from '../../functions/registrations/ageIntegrity'
import { RootState } from '../../store'

export const ParticipantSiblingForm = (props: {
  sibling: ISibling
  onCreateForm: (values: UseFormGetValues<FieldValues>, validator: Validator) => void
  onRemoveForm: () => void
}) => {
  const { sibling, onCreateForm, onRemoveForm } = props
  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations,
  )
  const { age_check_tolerance } = useSelector(
    (state: RootState) => state.program.data,
  )
  const validationSchema = yup.object().shape({
    ...siblingSchema,
    date_of_birth: siblingSchema.date_of_birth.test({
      name: 'proper_age_check',
      test: function(value) {
        const res = checkProperAge(value, registrations, age_check_tolerance)
        return res.ok && !res.message
          ? true
          : this.createError({ path: 'date_of_birth', message: res.message })
      },
    }),
  })
  const { register, formState, formState: { errors }, getValues, setValue, trigger } = useForm(
    {
      resolver: yupResolver(validationSchema),
      mode: 'onChange',
    },
  )
  const [showDisabled, setShowDisabled] = useState(!!sibling.disabled)

  const formFieldProperties = {
    person: sibling,
    loadedViaCode: false, // Can't be used together with the sibling mode
    errors,
    formState,
    register,
  }

  useEffect(() => {
    onCreateForm(getValues, { trigger, formName: 'ParticipantSiblingForm' })
  })

  return (
    <Form className='border rounded p-3'>
      {useMediaQuery(isTabletOrMobileQuery) ? (
        <>
          <Form.Row>
            <FirstNameField formFieldProperties={formFieldProperties} />
          </Form.Row>
          <Form.Row>
            <GenderField formFieldProperties={formFieldProperties} />
          </Form.Row>
        </>
      ) : (
        <>
          <Form.Row>
            <FirstNameField formFieldProperties={formFieldProperties} />
            <GenderField formFieldProperties={formFieldProperties} />
          </Form.Row>
        </>
      )}
      <Form.Row>
        <DateOfBirthField formFieldProperties={formFieldProperties} />
      </Form.Row>
      <Form.Row>
        <DisabledField formFieldProperties={formFieldProperties} setShowDisabled={setShowDisabled} sibling={true}/>
      </Form.Row>
      {showDisabled ? (
        <>
          <Form.Row>
            <HandicapField formFieldProperties={formFieldProperties}/>
          </Form.Row>
        </>
      ) : (
        <></>
      )}
      <Form.Row className='pt-3'>
        <Col>
          <Form.Group>
            <Button
              variant='danger'
              onClick={onRemoveForm}
              className='mobile-btn mb-0'
            >
              Entfernen
            </Button>
          </Form.Group>
        </Col>
      </Form.Row>
    </Form>
  )
}
